import React from 'react';
import Dialog from '../adapters/Dialog'
import Button from '../adapters/Button';

import {useDispatch} from "react-redux";
//import {toggleModal} from '../../redux/application';

import GetSignParams from './GetSignParams';
import {authorizeBySign} from '../../redux/user';

export default function LoginWithSign({open, toggle}) {

  const dispatch = useDispatch();

  const handleApplySign = () => {
    dispatch(authorizeBySign());
  };

  const content =
    <GetSignParams/>

  const actions = <React.Fragment>
    <Button onClick={handleApplySign}>Увійти </Button>
    <Button onClick={() => toggle(false)}> Відмінити </Button>
  </React.Fragment>;

  return (
    <Dialog
      open={open}
      title="Авторизація за допомогою КЕП"
      content={content}
      actions={actions}
    />)

}